import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AxiosError } from 'axios';
import {
  BookingApiService,
  RecurringBookingPredictionDTO,
  recurringBookingsQueryKeys,
} from 'features/bookings';

const { recurringBookingPrediction } = BookingApiService();

export const useRecurringBookingPrediction = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: RecurringBookingPredictionDTO) => {
      return recurringBookingPrediction(payload);
    },
    {
      onError: (error: AxiosError) => {
        const uiMessage = handleError(error);

        if (uiMessage) message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: recurringBookingsQueryKeys.all,
        });
      },
    },
  );
};
